import { Formity, type OnReturn } from "@formity/react";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";
import { schema, type Values } from "./-form";

export const Route = createFileRoute("/_www/buchen/gruppe")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Gruppenanfrage – Alte Papierfabrik Wuppertal",
      description:
        "Gruppenanfrage für die Alte Papierfabrik Wuppertal – Bowling und Minigolf für Gruppen, Firmenfeiern und Events.",
      path: "/buchen/gruppe",
    }),
});

function RouteComponent() {
  const onReturn = useCallback<OnReturn<{}>>(() => {}, []);

  return (
    <ScaffoldSection>
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Gruppenbuchung</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <Formity<Values> onReturn={onReturn} schema={schema} />
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
